import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "rp_token";
export const ACT_AS_KEY = "rp_act_as";
export const WORKSPACE_KEY = "rp_workspace";

export const api = axios.create({ baseURL: API_BASE, timeout: 120000 });

export function getActAs() {
  try {
    const raw = localStorage.getItem(ACT_AS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getWorkspaceId() {
  try {
    return localStorage.getItem(WORKSPACE_KEY) || null;
  } catch {
    return null;
  }
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const actAs = getActAs();
  if (actAs?.owner_id && !config.skipActAs) config.headers["X-Act-As"] = actAs.owner_id;
  // Aktiv virksomhet (primær = ingen header). Ignoreres av backend for kontonivå-stier og ved fullmakt.
  const ws = getWorkspaceId();
  if (ws && !actAs?.owner_id && !config.skipWorkspace) config.headers["X-Workspace"] = ws;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(ACT_AS_KEY);
      localStorage.removeItem(WORKSPACE_KEY);
      window.dispatchEvent(new CustomEvent("rp:unauthorized"));
    }
    return Promise.reject(error);
  }
);

export function errorMessage(error, fallback = "Noe gikk galt. Prøv igjen.") {
  const d = error?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  if (error?.code === "ECONNABORTED") return "Tidsavbrudd. Prøv igjen.";
  return fallback;
}

export async function downloadFile(url, filename, params) {
  const res = await api.get(url, { responseType: "blob", params });
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
}
